
export {NIL,
parse,
stringify,
v1,
v3,
v4,
v5,
validate,
version} from '../../frontend-js-dependencies-web/__liferay__/exports/uuid.js';
